import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  public isVendorLogin = new BehaviorSubject<boolean>(false);
  public loginStatus = new BehaviorSubject<boolean>(false);
  public tagsEnabled = new BehaviorSubject<boolean>(false);

  constructor(private readonly http: HttpClient) { }

  private getAppId(appName: string): string {
    if (appName === "kepler") {
      return "KyVU6I09";
    }
    if (appName === "rubin") {
      return "Q68VYEuP";
    }
    return "";
  }

  setVendor(value = false) {
    this.isVendorLogin.next(value);
  }

  setTagsEnabled(value = false) {
    this.tagsEnabled.next(value);
  }

  setLoginStatus(value = false) {
    this.loginStatus.next(value);
  }

  login(payload: any, appName: string) {
    const appId = this.getAppId(appName);
    return this.http.post(`api-token-auth/?app_id=${appId}`, payload);
  }

  otplogin(payload: any, appName: string) {
    const appId = this.getAppId(appName);
    return this.http.post(`vendors/otp/verify/?app_id=${appId}`, payload);
  }
  verifyUserToken(token: any) {
    const data = { token };
    return this.http.post(`api-token-verify/`, data);
  }
  loginSSO(payload: any) {
    return this.http.post(`users/check-user-exists/`, payload);
  }

  signupuser(payload: any) {
    return this.http.post(`users/register/`, payload);
  }
  createotp(payload: any) {
    return this.http.post(`users/create-otp/`, payload);
  }
  verifyotp(payload: any) {
    return this.http.post(`users/verify-otp/`, payload);
  }
  createuser(payload: any) {
    return this.http.post(`users/create-user/`, payload);
  }

  changepassword(data: any, token: any) {
    const headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `JWT ${token}`);
    return this.http.post("api-password-reset-confirm/", JSON.stringify(data), {
      headers,
    });
  }

  changePassword(payload: any) {
    return this.http.post(`users/change-password/`, payload);
  }

  getLinkPasswordResetLink(data: any) {
    return this.http.post(`api-password-reset/`, data);
  }
  verifyToken(token: any) {
    return this.http.post(`api-password-reset-verify/`, token);
  }

  getTokenfromSSO(profile: any, appName: string) {
    let userDomain = window.location.host?.split(".")?.[0];
    let tenant = userDomain;
    const appId = this.getAppId(appName);
    if (userDomain?.includes("localhost")) {
      tenant = "titan";
    }
    let env: any = environment.tenant_info;
    const token_key: any = localStorage.getItem(
      "msal.token.keys." + env[tenant].CLIENT_ID
    );
    const msal_token: any = JSON.parse(
      localStorage.getItem(JSON.parse(token_key).idToken[0]) as string
    );
    const payload = {
      first_name: profile.givenName,
      last_name: profile.surname,
      email: profile.userPrincipalName,
      token: msal_token?.secret,
    };
    return this.http.post(`users/get-token-by-sso/?app_id=${appId}`, payload);
  }

  triggerOtp(data: any) {
    return this.http.post(`vendors/otp/`, data);
  }

  getTenantInfo() {
    return this.http.get("my-tenant/");
  }

  logoutOnServer(appName: string) {
    const appId = this.getAppId(appName);
    return this.http.post(`users/logout/?app_id=${appId}`, {});
  }
}
